module.exports = __webpack_public_path__ + "img/entityEle.bc5ed0c2.svg";